import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const SwitchIconContainer = styled.svg`
  fill: ${props => (props.theme.LABEL === 'catapult' ? props.theme.WARNING : props.theme.PRIMARY)};
  margin: 0px 20px;
`;

const PrimaryColorText = styled.p`
  color: ${props => props.theme.PRIMARY};
  font-size: 20px;
  font-weight: 300;
`;

function SwitchIcon() {
  return (
    <SwitchIconContainer
      id="NavigationBar.ProductSwitchIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </SwitchIconContainer>
  );
}

function NavigationBarLeft({ t }) {
  return (
    <Container>
      <SwitchIcon />
      <PrimaryColorText id="NavigationBar.Text">{t('NavigationBar.Text.Setup')}</PrimaryColorText>
    </Container>
  );
}

NavigationBarLeft.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

export default withTranslation()(NavigationBarLeft);
